// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p217 кнопка Σ — річні підсумки за опцією, типово вимкнено)
// Колонки годового итога REPORT2 (бэк data_layout2: группа «Total» последней в группе года, binding '_total::<YYYY>::<поле>', collapseTo группы года —
// на неё) отрисованы всегда, но по умолчанию спрятаны (col.visible = false): между Груднем и Січнем следующего года ничего не врезается. Кнопка Σ
// в полосе опций шапки виджета (после кнопок групп опций) показывает их — без перезапроса бэка, только видимость колонок wijmo.
// Свёрнутый год (группа года или любой её предок свёрнуты) показывает итог всегда — иначе год пропал бы целиком (wijmo у свёрнутой группы
// видит только collapseTo, а visible = false колонки сильнее). Выключатель fe.ux.yearTotalsButton (дефолт ВКЛ, §8): ВЫКЛ — как раньше,
// колонки видны всегда, кнопки нет. Состояние кнопки — в памяти виджета (WIDGET._yearTotalsOn), в запись не пишется.
export const YEAR_TOTALS_FLAG = 'fe.ux.yearTotalsButton'
const flagOn = (setting, k) => { try { return typeof setting === 'function' ? setting(k, true) !== false : true } catch (e) { return true } }
export const yearTotalsButton_on = (setting) => flagOn(setting, YEAR_TOTALS_FLAG)

const YEAR_TOTAL_RE = /^_total::(\d{4})::/
// binding колонки годового итога → год ('2027') или ''
export function yearTotal_year(binding) {
    const m = YEAR_TOTAL_RE.exec(String(binding || ''))
    return m ? m[1] : ''
}
export const yearTotal_isBinding = (binding) => !!yearTotal_year(binding)

// план видимости: groups — дерево групп колонок wijmo (getColumnGroups(): { columns, isCollapsed }), листья — колонки ({ binding }).
// on — кнопка нажата, flag — выключатель. → { has: есть ли колонки годового итога, items: [{ col, hide, year, collapsed, measure, monthW }] } — hide: спрятать
// колонку итога (кнопка отжата, флаг вкл и год развёрнут). Год свёрнут — свёрнута группа-предок, в которой есть не только итоги (группа «Всього» из одних
// итогов при раскрытии года сворачивается drill-down'ом — это не свёртка года). measure — мера ячеек-дат года (первая колонка-дата группы года),
// monthW — ширина колонки-даты этой меры (последней в году) для приглушённого вида
// IE 2026 11 02 / ODOO-350449 (дополнение Игоря к p217, вариант 1: развёрнутый год — приглушённый итог, свёрнутый — остаток на начало года)
const DATE_RE = /^(\d{4}-\d{2}-\d{2})\.(.+)$/
export function yearTotals_plan(groups, { on = false, flag = true } = {}) {
    const items = []
    const leavesOf = (g, out = []) => { for (const c of (g && g.columns) || []) { if (c && c.columns && c.columns.length) leavesOf(c, out); else if (c) out.push(c) } return out }
    const walk = (gs, collapsed, yearLeaves, depth) => {
        if (depth > 16) return
        for (const g of gs || []) {
            if (!g) continue
            if (g.columns && g.columns.length) {
                const lv = leavesOf(g)
                const other = lv.some(c => !yearTotal_isBinding(c.binding))
                walk(g.columns, collapsed || (!!g.isCollapsed && other), other ? lv : yearLeaves, depth + 1)
                continue
            }
            if (!yearTotal_isBinding(g.binding)) continue
            const yr = yearTotal_year(g.binding)
            let measure = '', monthW = 0
            for (const c of yearLeaves || []) {
                const m = DATE_RE.exec(String(c.binding || ''))
                if (!m || m[1].slice(0, 4) !== yr) continue
                if (!measure) measure = m[2]
                if (m[2] === measure) monthW = Number(c.renderWidth || c.width) || monthW
            }
            items.push({ col: g, hide: !!flag && !on && !collapsed, year: yr, collapsed: !!collapsed, measure, monthW })
        }
    }
    walk(groups, false, null, 0)
    return { has: items.length > 0, items }
}

// IE 2026 11 02 / ODOO-350449 (дополнение Игоря к p217, вариант 1): вид ячейки итога года.
// Свёрнутый год — обычный вид; у строки запаса — остаток на начало года ('opening'). Развёрнутый (виден по Σ) — приглушённый ('muted'; строка запаса —
// «—» без заливки 'muted-stock'; блок «Непокрито» — мелкое красное число 'muted-unc'); выключатель fe.ux.yearTotalsMuted ВЫКЛ — обычный вид ('normal')
export const YEAR_TOTALS_MUTED_FLAG = 'fe.ux.yearTotalsMuted'
export const yearTotalsMuted_on = (setting) => flagOn(setting, YEAR_TOTALS_MUTED_FLAG)
export function yearTotal_cellMode({ collapsed = false, muted = true, stock = false, unc = false } = {}) {
    if (collapsed) return stock ? 'opening' : 'normal'
    if (!muted) return 'normal'
    return stock ? 'muted-stock' : (unc ? 'muted-unc' : 'muted')
}
// строка блока «Непокрито»: красная заливка строки (классы alert-uncovered / alert-row у строки или у ячейки до снятия сигналов p201) или поле alert = uncovered.
// Отбор блока (_DLRow.where_block) не годится: на dev02 он ловил и строки блока «−» (проба p217: «Відвантаження з МС» красным)
export function yearTotal_uncIs(dataItem, cellClasses) {
    const has = (list) => { const arr = Array.isArray(list) ? list : (typeof list === 'string' ? list.split(/\s+/) : (list && typeof list.length === 'number' ? Array.from(list) : [])); return arr.some(c => c === 'alert-uncovered' || c === 'alert-row') }
    if (has(cellClasses)) return true
    if (dataItem && typeof dataItem === 'object') {
        if (/^uncovered$/i.test(String(dataItem.alert ?? '').trim())) return true
        if (has(dataItem._DLRow && dataItem._DLRow.cssClasses)) return true
    }
    return false
}
export const YEAR_TOTAL_MODE_CLASSES = ['yt-muted', 'yt-muted-stock', 'yt-muted-unc', 'yt-opening']
export function yearTotal_modeClasses(mode) {
    if (mode === 'muted') return ['yt-muted']
    if (mode === 'muted-stock') return ['yt-muted', 'yt-muted-stock']
    if (mode === 'muted-unc') return ['yt-muted', 'yt-muted-unc']
    if (mode === 'opening') return ['yt-opening']
    return []
}
// ширина приглушённой колонки — 70 % колонки месяца (не уже 40 px)
export const yearTotal_mutedWidth = (monthW) => (Number(monthW) > 0 ? Math.max(40, Math.round(Number(monthW) * 0.7)) : 0)

const isNum = (v) => v !== undefined && v !== null && v !== '' && Number.isFinite(Number(v))
// значение меры строки на дату (ячейка-объект dataItem[date][measure]) → число | null
export function yearTotal_valueAt(dataItem, date, measure) {
    const c = date && dataItem && typeof dataItem === 'object' ? dataItem[date] : null
    const v = c && typeof c === 'object' ? c[measure] : undefined
    return isNum(v) ? Number(v) : null
}
// даты года в списке дат меры (по возрастанию) + соседи: последняя дата до года и первая после
export function yearTotal_dates(allDates, year) {
    const arr = (Array.isArray(allDates) ? allDates : []).slice().sort()
    const pre = String(year) + '-'
    const inYear = arr.filter(d => String(d).startsWith(pre))
    if (!inYear.length) return { dates: [], prev: '', next: '' }
    const i0 = arr.indexOf(inYear[0]), i1 = arr.indexOf(inYear[inYear.length - 1])
    return { dates: inYear, prev: i0 > 0 ? arr[i0 - 1] : '', next: i1 < arr.length - 1 ? arr[i1 + 1] : '' }
}
// остаток на начало года: значение первого периода года, который есть в горизонте (первая дата года с числом); нет — null
export function yearTotal_opening(dataItem, measure, yearDates) {
    for (const d of (Array.isArray(yearDates) ? yearDates : [])) {
        const v = yearTotal_valueAt(dataItem, d, measure)
        if (v !== null) return v
    }
    return null
}
// кривая запаса через колонку итога: свёрнутый год — кусок площади prev → остаток на начало → правый край как у соседа справа
// (середина между последним месяцем года и первым после него: next' = last + after − value); развёрнутый — «мост» на уровне той же середины.
// → аргументы cellArea_segment { prev, value, next } | null
export function yearTotal_areaArgs({ collapsed, prevVal = null, opening = null, lastVal = null, afterVal = null }) {
    if (collapsed) {
        if (opening === null) return null
        const next = (lastVal !== null && afterVal !== null) ? lastVal + afterVal - opening : (afterVal !== null ? afterVal : null)
        return { prev: prevVal, value: opening, next }
    }
    if (lastVal === null) return null
    const mid = afterVal !== null ? (lastVal + afterVal) / 2 : lastVal
    return { prev: mid, value: mid, next: mid, bridge: true }
}

// IE 2026 11 03 / ODOO-350449 (заказ Игоря: p233 Σ не смикає панель команд): «у виджета есть итоги года» (WIDGET._yearTotalsHas → кнопка Σ в шапке) —
// ИЛИ по всем гридам виджета, а не последний записавший: грид без итогов (другая вкладка / секция того же виджета) в своём yearTotals_sync сбрасывал флаг,
// шапка перестраивалась без Σ, а следующий sync грида с итогами возвращал её — узел кнопки пересоздавался (AttrButton монтируется невидимым), ряд кнопок
// панели прыгал на ширину Σ (проба dev02 p233: 31 px, CLS 0,0018 на каждый клик). by — память «грид → есть итоги» (WIDGET._yearTotalsHasBy), key — грид,
// mine — у этого грида есть итоги (null — грид уходит, забыть). Выключатель fe.ux.sigmaSteadyPanel (дефолт ВКЛ, §8): ВЫКЛ — как раньше, решает последний грид
export const SIGMA_STEADY_FLAG = 'fe.ux.sigmaSteadyPanel'
export const sigmaSteady_on = (setting) => flagOn(setting, SIGMA_STEADY_FLAG)
export function yearTotals_hasMerge(by, key, mine, steady = true) {
    if (!steady) return !!mine
    if (by && key != null) { if (mine === null || mine === undefined) delete by[key]; else by[key] = !!mine }
    return !!by && Object.keys(by).some(k => by[k])
}

// видимость колонки итога с учётом прочих скрытий (группа опций выключена, колонка пуста при «непустых»)
export function yearTotals_want(hide, attr_col) {
    return !hide && !(attr_col && (attr_col._ogHide || attr_col.hide_beacose_empty))
}

// кнопка шапки: фронтовая (front_only), без запроса; квадратная с «Σ» (CSS .yt-sigma, Widget.vue); нажата = итоги видны
export function yearTotals_button(prev, on, tr = (s) => s) {
    const b = prev || { attr_type: 'AttrButton', command: 'executeVueObjMethod', method: 'yearTotals_toggle', front_only: true, name: 'year-totals', showCommandTitle: false }
    b.cssClass = 'p-button-white yt-sigma'
    b.title = tr('Year totals')
    b.tooltip = on ? tr('Year totals are shown. Click — hide the total columns of each year') : tr('Year totals are hidden. Click — show the total columns of each year')
    b.uiHelp = 'widget.header.btn.yearTotals'
    b.uiHelpState = on ? 'on' : 'off'
    b.active = !!on
    return b
}

// место кнопки в панели: после последней кнопки группы опций (toggle_option_group); нет их — в конце
export function yearTotals_insertAt(panel) {
    let at = -1
    ;(panel || []).forEach((c, i) => { if (c && c.method === 'toggle_option_group') at = i })
    return at >= 0 ? at + 1 : (panel || []).length
}
